import { CycleUtils, ECLIPSE_BUSINESS_ELITE_PRODUCT_FAMILY_ID, ENTERPRISE_PRODUCT_FAMILY_ID, ECLIPSE_BUSINESS_PRODUCT_FAMILY_ID, ECLIPSE_CORE_PRODUCT_FAMILY_ID, ECLIPSE_LIGHT_PRODUCT_FAMILY_ID } from '@wix/package-picker-shared';
export const recommendedCycleToPurchaseCycle = recommended => recommended ? CycleUtils.convertCycleIdToCycle(recommended) ?? undefined : undefined;
const FAMILY_BY_PRODUCT_FAMILY_ID = {
  [ECLIPSE_LIGHT_PRODUCT_FAMILY_ID]: 'Light',
  [ECLIPSE_CORE_PRODUCT_FAMILY_ID]: 'Core',
  [ECLIPSE_BUSINESS_PRODUCT_FAMILY_ID]: 'Business',
  [ECLIPSE_BUSINESS_ELITE_PRODUCT_FAMILY_ID]: 'Business Elite',
  [ENTERPRISE_PRODUCT_FAMILY_ID]: 'Business Elite'
};
export const productFamilyFromId = productFamilyId => productFamilyId ? FAMILY_BY_PRODUCT_FAMILY_ID[productFamilyId] : undefined;
export const availableCyclesFromPricingDetails = pricingDetails => CycleUtils.sortCyclesByDuration((pricingDetails ?? []).map(detail => detail.cycle ?? undefined));
export const clampToAvailableCycle = (recommended, availableCycles) => {
  if (availableCycles.length === 0) {
    return recommended;
  }
  const recommendedMonths = CycleUtils.convertCycleDurationToMonths(recommended);
  const atOrBelow = availableCycles.filter(cycle => CycleUtils.convertCycleDurationToMonths(cycle) <= recommendedMonths);
  return CycleUtils.maxCycle(atOrBelow) ?? CycleUtils.minCycle(availableCycles) ?? recommended;
};
//# sourceMappingURL=cycleRecommendation.utils.js.map